// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { BankAccount } from '@client/banks/types/account';
import type { UpdateBankInstitution } from '@client/banks/types/institution';
import { toWireOptionalIban } from '@client/banks/utils/account-reference';
import type { UpdateAdvisoryAccountsCitecRequestBody } from '@shared/data-access/types/brokerage/advisory-accounts-citec';

const mapInstitutionWire = (institution: UpdateBankInstitution) => ({
  id: institution.id,
  name: institution.name,
  logo_url: institution.logoUrl || null,
});

export const mapBankAccountToCitecWire = (account: BankAccount) => ({
  iban: toWireOptionalIban(account.iban),
  name: account.name,
  currency: account.currency,
  account_type: account.accountType,
  owners: account.owners.map(owner => ({
    name: owner.name,
    role: '',
  })),
  available: account.available ?? null,
  balance_date: account.balanceDate || null,
});

export const buildUpdateInstitutionPayload = (
  institution: UpdateBankInstitution,
): UpdateAdvisoryAccountsCitecRequestBody => ({
  institution: mapInstitutionWire(institution),
});

export const buildUpdateAccountPayload = (
  institution: UpdateBankInstitution,
  account: BankAccount,
): UpdateAdvisoryAccountsCitecRequestBody => ({
  institution: mapInstitutionWire(institution),
  accounts: [mapBankAccountToCitecWire(account)],
});
